
import { defineComponent, onMounted, ref, reactive,computed, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { ScrollComponent } from "@/assets/ts/components/_ScrollComponent";
import { MenuComponent } from "@/assets/ts/components/MenuComponent";
import { version } from "@/core/helpers/documentation";
import { asideMenuIcons } from "@/core/helpers/config";
import MainMenuConfig, {getMenu, getUserMenu} from "@/core/config/MainMenuConfig";
import {role} from "@/helpers/role"

export default defineComponent({
  name: "kt-menu",
  components: {},
  setup() {
    const { t, te } = useI18n();
    const route = useRoute();
    const store = useStore();
    const scrollElRef = ref<null | HTMLElement>(null);
    onMounted(() => {
      ScrollComponent.reinitialization();
      MenuComponent.reinitialization();
      if (scrollElRef.value) {
        scrollElRef.value.scrollTop = 0;
      }
    });

    const currentUser = store.getters.currentUser;

    const selectPartner = computed(() => store.getters.getRepresentId);

    const linkPrefix = computed(() => "/partners/" + ( selectPartner.value == "" ? "" :  selectPartner.value ))

    // const currentRole = ref(store.getters.currentRole) 
    const currentRole = computed(() => store.getters.currentRole);
    
    const mainMenuConfig = reactive([...getUserMenu()])
    const representPartner = computed(() => store.getters.representPartner)
    

    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };

    const hasActiveChildren = (match) => {
      const fullMatch = linkPrefix.value + match;
      return route.path === fullMatch || route.path.startsWith(fullMatch + '/');
    };

    const chackRole = (roles: string[]): boolean => {
      return !roles || !roles.length || roles.includes(currentRole.value);
    };

    return {
      hasActiveChildren,
      mainMenuConfig,
      asideMenuIcons,
      version,
      translate,
      chackRole,
      selectPartner,
      currentRole,
      linkPrefix,
      representPartner
    };
  },
});
